import { http } from 'utils'

// Job history mutation imports.
import { SET_JOB_HISTORY } from 'vx/mutations'

// Job history state.
const state = {
  history: []
}

// Job history state getters.
const getters = {}

// Job history actions.
const actions = {
  /**
   * Get job history.
   */
  getHistory ({ commit, rootState: { job: jobState } }) {
    return http.get(`jobs/${jobState.job.id}/history`).then(response => {
      commit(SET_JOB_HISTORY, response.data)

      return response
    })
  }
}

// Job history state mutations.
const mutations = {
  /**
   * Set the job history.
   */
  [SET_JOB_HISTORY] (state, history) {
    state.history = history
  }
}

// Export our state, getters, actions, and mutations.
export default {
  namespaced: true, state, getters, actions, mutations
}



// WEBPACK FOOTER //
// ./src/vuex/modules/job/history.js